var $body = $("body");
var $styleToggleButton = $(".style-toggle");
var variant_two = "variant-2";
//Set layout on page load
if (typeof Storage !== "undefined") {
    if (localStorage.alternative_layout) {
        if (localStorage.alternative_layout === "true") {
            $body.addClass(variant_two);
        }
        else {
            $body.removeClass(variant_two);
        }
    }
}
var toggleStyle = function () {
    $body.toggleClass(variant_two);
    if (typeof Storage !== "undefined") {
        localStorage.setItem("alternative_layout", $body.hasClass(variant_two).toString());
    }
};
$(document).keydown(function (e) {
    if (e.ctrlKey && e.key == "e") {
        toggleStyle();
        e.preventDefault();
    }
});
$styleToggleButton.click(function () { return toggleStyle(); });
var $imageGrid = $('.image-grid');
var $body = $('body');
var $imageGallery = function () { return $('.gallery-viewer'); };
var $galleryHolder = function () { return $('.gallery-holder'); };
var $imageGalleryButtonNext = function () { return $imageGallery().find('.button-next'); };
var $imageGalleryButtonPrev = function () { return $imageGallery().find('.button-prev'); };
var $imageGalleryButtonClose = function () { return $imageGallery().find('.button-close'); };
var $nthImage = function (index) { return $galleryHolder().children().eq(index); };
var $nthImageImage = function (index) { return $nthImage(index).children('img'); };
var $nthImageCaption = function (index) { return $nthImage(index).children('figcaption'); };
var galleryImages = [];
var initializeGallery = function (figure) {
    if (!$body.hasClass('gallery')) {
        var $galleryViewer = $('<div/>', { "class": 'gallery-viewer' });
        //Add images to array
        galleryImages = [];
        for (var _i = 0, _a = $imageGrid.children("figure").toArray(); _i < _a.length; _i++) {
            var fig = _a[_i];
            galleryImages.push({
                image: $(fig).children('img').data('orig').toString(),
                low_res: $(fig).children('img').attr('src').toString(),
                description: $(fig).children('figcaption').html().toString()
            });
        }
        var index = $imageGrid.children('figure').index(figure);
        var $holder = $('<div/>', { "class": "gallery-holder" });
        var $nextButton = $('<div/>', { "class": "button-next" });
        var $prevButton = $('<div/>', { "class": "button-prev" });
        var $closeButton = $('<div/>', { "class": "button-close" });
        for (var _b = 0, galleryImages_1 = galleryImages; _b < galleryImages_1.length; _b++) {
            var object = galleryImages_1[_b];
            $('<figure/>')
                .append($('<img/>', { src: object.low_res }))
                .append($('<figcaption/>', { text: object.description }))
                .appendTo($holder);
        }
        $galleryViewer
            .append($nextButton)
            .append($prevButton)
            .append($closeButton)
            .append($holder);
        $galleryViewer.appendTo($('main'));
        $galleryViewer.on('click', function (event) {
            if (event.target == event.currentTarget)
                closeGallery();
        });
        $imageGalleryButtonClose().on('click', function () { return closeGallery(); });
        showPicture(index);
        $body.addClass('unscrollable');
    }
};
var closeGallery = function () {
    $imageGallery().remove();
    $body.removeClass('unscrollable');
};
var showPicture = function (index) {
    //If low res is being shown
    if ($nthImageImage(index).attr("src").toString() != galleryImages[index].image) {
        var preload = new Image();
        $(preload).attr({ src: galleryImages[index].image });
        //If on cache
        if (preload.complete) {
            $nthImageImage(index).attr("src", galleryImages[index].image);
        }
        else {
            $(preload).on("load", function () {
                $nthImageImage(index).attr("src", galleryImages[index].image);
            });
        }
    }
    $nthImageCaption(index).html(galleryImages[index].description);
    var nextIndex = index == galleryImages.length - 1 ? 0 : index + 1;
    var prevIndex = index == 0 ? galleryImages.length - 1 : index - 1;
    $nthImage(index).on("swipeleft", function () { return showPicture(nextIndex); });
    $nthImage(index).on("swiperight", function () { return showPicture(prevIndex); });
    for (var i = 0; i < galleryImages.length; i++) {
        $nthImage(i).removeClass("prev next current");
        if (i != index)
            $nthImage(i).off("swipeleft swiperight");
        //Direct previous || if index ==0, then if last
        if (i == index - 1 || index == 0 && i == galleryImages.length - 1) {
            $nthImage(i).addClass("prev");
        }
        //Direct next || if index is last, then if first
        else if (i == index + 1 || index == galleryImages.length - 1 && i == 0) {
            $nthImage(i).addClass("next");
        }
        else if (i == index) {
            $nthImage(i).addClass("current");
        }
    }
    $imageGalleryButtonNext().off().one('click', function () { return showPicture(index + 1 > galleryImages.length - 1 ? 0 : index + 1); });
    $imageGalleryButtonPrev().off().one('click', function () { return showPicture(index - 1 < 0 ? galleryImages.length - 1 : index - 1); });
};
$imageGrid.children('figure').on('click', function (event) {
    initializeGallery(event.currentTarget);
});
var navButton = $('#menu-button');
var navbar = $('#navbar');
navButton.click(function () {
    var isActive = navbar.hasClass("active");
    if (isActive) {
        navbar.height(navbar.innerHeight());
        navbar.animate({
            height: 0
        }, 250, function () {
            navbar.removeClass("active");
        });
    }
    else {
        navbar.animate({
            height: navbar[0].scrollHeight
        }, 250, function () {
            navbar.addClass("active");
            navbar.height("auto");
        });
    }
});

//# sourceMappingURL=script.js.map
